import { render, staticRenderFns } from "./PurchaseOrdersList.vue?vue&type=template&id=7e0945bb&"
import script from "./PurchaseOrdersList.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrdersList.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrdersList.vue?vue&type=style&index=0&id=7e0945bb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports